import { differenceWith, fromPairs, isEqual, toPairs } from 'lodash'

const getChangedFields = <T extends object>({
  currentValues,
  initialValues,
}: {
  currentValues: T
  initialValues: T
}) => {
  return fromPairs(
    differenceWith(toPairs(currentValues), toPairs(initialValues), isEqual),
  )
}

export default getChangedFields
